module.exports = __webpack_public_path__ + "img/vpn-6.c58ca6d2.webp";